import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TriggerGroupObjectFieldEntity } from './trigger-group-object-field.entity';

@Entity('_trigger_group__object')
export class TriggerGroupObjectEntity extends BaseEntity {
	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('int', { name: '_fk__trigger_group__id', unsigned: true })
	public fkTriggerGroupId!: number;

	@Column('varchar', { name: '_manipulation', length: 255 })
	public manipulation!: string;

	@OneToMany(
		() => TriggerGroupObjectFieldEntity,
		(triggerGroupObjectField) => triggerGroupObjectField.fkTriggerGroupObject,
		{},
	)
	public triggerGroupObjectFields!: Array<TriggerGroupObjectFieldEntity>;
}
